import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BillingManagementService } from '../../../service/billing-management.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, GeneralConfigType, InteractionType, KeyValueSet, LocalService, NumericConfig, PageKey, RelationShipRole, Status, Wrappers5 } from '../../../service/local.service';

@Component({
  selector: 'app-prepaid',
  templateUrl: './prepaid.component.html',
  styleUrls: ['./prepaid.component.scss']
})
export class PrepaidComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["prepaid"]; prepaidReasons: KeyValueSet[]; amountToRecharge: number = null;
  wrapper: Wrappers5; maxBodyHeight = 0; isShowPayment: boolean = false;
  ctryCode: string = ''; userId: string = ''; businessId: string = ''; interactionType: InteractionType;
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig; RelationShipRole = RelationShipRole;

  elementIds: any = {
    txt_amount: 'txt_amount'
  };

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, public billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.PrepaidDetailReason).subscribe(result => {
      this.prepaidReasons = result;
    });
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.businessId = routeParams.businessId;
      if (this.interactionType == InteractionType.User)
        this.businessId = this.userId;
      if (this.interactionType == InteractionType.Business || this.interactionType == InteractionType.Bill_PnixSoft)
        this.configurationManagementService.ensurePageActions(PageKey.PrepaidBusiness, this.businessId);
      else if (this.interactionType == InteractionType.ServiceProvider)
        this.configurationManagementService.ensurePageActions(PageKey.PrepaidServiceProvider);
      else
        this.configurationManagementService.ensurePageActions(PageKey.PrepaidUser);
      if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else if (this.interactionType == InteractionType.ServiceProvider && (this.businessId == '' || this.businessId == '0')) {
        this.localService.onDirectToServiceProviderCreation();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(40);
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      setTimeout(() => {
        this.localService.onFocusNextInput(this.elementIds.txt_amount, FocusInputType.TextBox, false, true);
      }, 1000);

      this.billingManagementService.getPrepaidDetails(this.businessId, this.interactionType, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
        this.wrapper = result;
      });
    }
  }

  onAddAmount() {
    if (this.amountToRecharge && this.amountToRecharge > 0) {
      this.isShowPayment = true;
    } else {
      this.localService.showInformation(this.localService.languageContent.prepaid.amt_required, true);
      this.localService.onFocusNextInput(this.elementIds.txt_amount, FocusInputType.TextBox);
    }
  }

  onPaymentProccesed(e: any) {
    this.amountToRecharge = null;
    this.onLoad();
  }
}
